import React, { useState } from 'react'
import { Description, Field } from '@headlessui/react'
import { Tooltip } from '@material-tailwind/react/components/Tooltip'
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline'
import { cn } from '../../../../Utils/component'
import { ErrorMessage } from '../ErrorMessage'

interface InputfileProps {
  description?: string
  label?: string
  disabled?: boolean
  name: string
  value?: File | null
  // eslint-disable-next-line no-unused-vars
  onChange: (value: File | null) => void
  error?: string
  styleType?: 'default' | 'small'
}

export const Inputfile = ({
  disabled = false,
  description,
  label,
  name,
  value,
  onChange,
  error,
  styleType = 'default',
}: InputfileProps) => {
  const [isDirty, setIsDirty] = useState<boolean>(false)

  return (
    <Field
      disabled={disabled}
      aria-label={label}
      className={cn('flex', styleType === 'default' && 'w-full')}
    >
      <div
        className={cn(
          'flex flex-col space-y-2',
          styleType === 'default' && 'flex-1',
        )}
      >
        {label && <p className="font-medium text-night text-sm/6">{label}</p>}
        {description && (
          <Description className="font-thin text-gray-500 text-sm/6">
            {description}
          </Description>
        )}

        <Tooltip
          animate={{
            mount: { scale: 1, y: 0 },
            unmount: { scale: 0, y: 25 },
          }}
          placement="top"
          className="px-4 py-3 border shadow-xl border-lamacompta-blue bg-very-light-blue shadow-black/10"
          content={
            <div className="space-y-1">
              <p className="text-sm text-center text-night">Dépose ton CV</p>
              <p className="text-xs text-gray-500">
                .pdf, .png ou .docx (MAX 3Mb)
              </p>
            </div>
          }
        >
          <label
            htmlFor={name}
            className={cn(
              'cursor-pointer',
              styleType === 'default' &&
              'flex flex-col items-center justify-center w-full border-2 border-blue-300 border-dashed rounded-lg h-38 bg-blue-50',
              styleType === 'small' &&
              'border border-lamacompta-blue bg-very-light-blue px-4 py-2 flex rounded-md',
              error && 'border-red-300 bg-red-50',
              disabled && 'cursor-not-allowed',
            )}
          >
            <div
              className={cn(
                'flex items-center justify-center',
                styleType === 'default' && 'flex-col pt-5 pb-6',
                styleType === 'small' && 'flex-row space-x-2 py-1',
              )}
            >
              <ArrowUpTrayIcon className="w-5 h-5 text-primary" />
              {value && 'name' in value && (
                <p className="text-sm text-gray-800 bold">
                  {(value as { name: string }).name}
                </p>
              )}
              {((styleType === 'small' && !(value && 'name' in value)) ||
                styleType === 'default') && (
                  <p className="text-sm text-primary">
                    <span className="font-semibold">Dépose ton CV</span>
                  </p>
                )}
              {styleType !== 'small' && (
                <p className="text-xs text-gray-500">
                  .pdf, .png ou .docx (MAX 3Mb)
                </p>
              )}
            </div>
            <input
              id={name}
              name={name}
              type="file"
              className="sr-only"
              accept=".pdf,.png,.docx"
              disabled={disabled}
              onChange={(val) => {
                if (!isDirty) {
                  setIsDirty(true)
                }
                if (val.target.files && val.target.files[0]) {
                  onChange(val.target.files[0])
                }
              }}
            />
          </label>
        </Tooltip>
        <ErrorMessage error={error} />
      </div>
    </Field>
  )
}
